/* EM Wishlist v1 — device-local (localStorage), geen account-sync.
   Key: em_wishlist_v1 = JSON-array van product-handles.
   Gebruikt door: snippets/wishlist-button.liquid ([data-wishlist-toggle]),
   header-badge ([data-wishlist-count]), sections/wishlist-page.liquid (#em-wishlist-root). */
(function () {
  'use strict';

  var KEY = 'em_wishlist_v1';

  /* ---------- storage ---------- */

  function read() {
    try {
      var list = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (h) { return typeof h === 'string' && h; }) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* private mode / storage vol — wishlist werkt dan alleen niet persistent */
    }
  }

  function has(handle) {
    return read().indexOf(handle) !== -1;
  }

  function add(handle) {
    var list = read();
    if (list.indexOf(handle) === -1) {
      list.push(handle);
      write(list);
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'AddToWishlist');
      }
    }
  }

  function remove(handle) {
    write(read().filter(function (h) { return h !== handle; }));
  }

  function toggle(handle) {
    if (has(handle)) {
      remove(handle);
      return false;
    }
    add(handle);
    return true;
  }

  /* ---------- UI sync ---------- */

  function updateBadge() {
    var count = read().length;
    var badges = document.querySelectorAll('[data-wishlist-count]');
    for (var i = 0; i < badges.length; i++) {
      badges[i].textContent = count > 0 ? String(count) : '';
    }
  }

  function syncButtons(scope) {
    var buttons = (scope || document).querySelectorAll('[data-wishlist-toggle]');
    for (var i = 0; i < buttons.length; i++) {
      var active = has(buttons[i].getAttribute('data-handle'));
      buttons[i].classList.toggle('is-active', active);
      buttons[i].setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  /* Eén gedelegeerde click-handler: werkt ook voor product-cards die via
     AJAX-filtering/paginering later in de DOM komen. */
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest ? evt.target.closest('[data-wishlist-toggle]') : null;
    if (!btn) return;
    evt.preventDefault();
    evt.stopPropagation();
    var handle = btn.getAttribute('data-handle');
    toggle(handle);
    syncButtons();
    updateBadge();
    var row = btn.closest('[data-wishlist-card]');
    if (row && !has(handle)) {
      row.parentNode.removeChild(row);
      renderEmptyIfNeeded();
    }
  });

  /* Init-state zetten op cards die na pageload geïnjecteerd worden. */
  var observer = new MutationObserver(function () {
    window.clearTimeout(observer._t);
    observer._t = window.setTimeout(function () {
      syncButtons();
      updateBadge();
    }, 150);
  });

  /* ---------- wishlist-pagina ---------- */

  function money(pence) {
    return '£' + (pence / 100).toFixed(2);
  }

  function imageUrl(src, width) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function cardHtml(p) {
    var img = imageUrl(p.featured_image, 540);
    var price = '<span class="wishlist-card__price">' + money(p.price) + '</span>';
    if (p.compare_at_price && p.compare_at_price > p.price) {
      price += ' <s class="wishlist-card__compare">' + money(p.compare_at_price) + '</s>';
    }
    return (
      '<div class="wishlist-card" data-wishlist-card>' +
        '<div class="wishlist-card__image">' +
          '<a href="' + p.url + '">' +
            (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
          '</a>' +
          '<button type="button" class="wishlist-toggle is-active" data-wishlist-toggle data-handle="' + p.handle + '" aria-pressed="true" aria-label="Remove from wishlist" title="Remove from wishlist">' +
            '<svg class="wishlist-icon wishlist-icon--outline" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
            '<svg class="wishlist-icon wishlist-icon--filled" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="wishlist-card__detail">' +
          '<a class="wishlist-card__title" href="' + p.url + '">' + escapeHtml(p.title) + '</a>' +
          '<div class="wishlist-card__prices">' + price + '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str || ''));
    return div.innerHTML;
  }

  function renderEmptyIfNeeded() {
    var root = document.getElementById('em-wishlist-root');
    if (!root) return;
    if (read().length === 0 || !root.querySelector('[data-wishlist-card]')) {
      root.innerHTML =
        '<div class="wishlist-empty">' +
          '<p>' + escapeHtml(root.getAttribute('data-empty-text') || 'Your wishlist is empty.') + '</p>' +
          '<a class="btn btn--primary" href="' + (root.getAttribute('data-browse-url') || '/collections/all') + '">' +
            escapeHtml(root.getAttribute('data-browse-text') || 'Discover the collection') +
          '</a>' +
        '</div>';
    }
  }

  function renderPage() {
    var root = document.getElementById('em-wishlist-root');
    if (!root) return;
    var handles = read();
    if (handles.length === 0) {
      renderEmptyIfNeeded();
      return;
    }
    var results = [];
    var pruned = [];
    var pending = handles.length;

    handles.forEach(function (handle, idx) {
      fetch('/products/' + handle + '.js')
        .then(function (res) {
          if (!res.ok) throw new Error('gone');
          return res.json();
        })
        .then(function (p) { results[idx] = p; })
        .catch(function () { pruned.push(handle); })  /* 404 → product gedraft/weg → prunen */
        .then(function () {
          pending -= 1;
          if (pending === 0) finish();
        });
    });

    function finish() {
      if (pruned.length) {
        write(read().filter(function (h) { return pruned.indexOf(h) === -1; }));
        updateBadge();
      }
      var cards = results.filter(Boolean).map(cardHtml).join('');
      root.innerHTML = cards
        ? '<div class="wishlist-grid">' + cards + '</div>'
        : '';
      renderEmptyIfNeeded();
    }
  }

  /* ---------- init ---------- */

  function init() {
    syncButtons();
    updateBadge();
    renderPage();
    if (document.body) {
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* klein debug/integratie-API */
  window.EMWishlist = { read: read, has: has, toggle: toggle, count: function () { return read().length; } };
})();
